import type { ServiceThread, ServiceTicket } from "@rakazo/contracts";
import { Mail, MessageSquare, MessagesSquare, Phone } from "lucide-react";

export const TICKET_CHANNELS = {
  email: { Icon: Mail, label: "Email" },
  text: { Icon: MessageSquare, label: "SMS" },
  call: { Icon: Phone, label: "Voice" },
  chat: { Icon: MessagesSquare, label: "Chat" },
};

export function TicketChannels({ threads }: { threads: ServiceThread[] }) {
  const channels = [...new Set(threads.map((thread) => thread.channel))];
  return (
    <span className="inline-flex shrink-0 items-center gap-1.5">
      {channels.map((channel) => {
        const { Icon, label } = TICKET_CHANNELS[channel];
        return (
          <span key={channel} role="img" aria-label={label} title={label}>
            <Icon aria-hidden="true" className="size-3.5" />
          </span>
        );
      })}
    </span>
  );
}

export function ticketContact(ticket: ServiceTicket) {
  return (
    [...new Set(ticket.threads.map((thread) => thread.address).filter(Boolean))].join(" · ") ||
    ticket.hq.email ||
    ticket.hq.contact
  );
}
